// actions.js
import * as actionTypes from "./actionsTypes";

export const setValueFacture = (newValue) => ({
  type: actionTypes.SET_VALUE_FACTURE,
  payload: newValue,
});

export const setStatutFacture = (newValue) => ({
  type: actionTypes.SET_STATUT_FACTURE,
  payload: newValue,
});
export const setCurrentPageFacture = (newCurrentPage) => ({
  type: actionTypes.SET_CURRENT_PAGE_FACTURE,
  payload: newCurrentPage,
});

export const setSortFieldFacture = (newSortField) => ({
  type: actionTypes.SET_SORT_FIELD_FACTURE,
  payload: newSortField,
});
export const setOrderFacture = (newOrder) => ({
  type: actionTypes.SET_ORDER_FACTURE,
  payload: newOrder,
});
